export const OFFER_GROUP_DOCUMENT_MODEL = "offer-group-document";

const offerGroupDocumentModel = {
  name: "",
  description: "",
  documentType: "",
  sourceDocument: null,
  responseDocument: null,
  rejectedDocuments: [],
  status: "",
  documents: {
    jsonApi: "hasMany",
    type: "file"
  },
  comments: {
    jsonApi: "hasMany",
    type: "comment"
  }
};

export default offerGroupDocumentModel;
